import React, { useContext, useEffect } from "react";
import HeroSection from "./NAVBAR/HOMECOMPONENTS/HeroSection";
import Section1 from "./NAVBAR/HOMECOMPONENTS/Section_1";
import NewAndNotification from "./NAVBAR/HOMECOMPONENTS/NewAndNotification";
import Marquee from "./NAVBAR/HOMECOMPONENTS/Marquee";
import CampusLife from "./NAVBAR/HOMECOMPONENTS/CampusLife";
import AboutCCSU from "./NAVBAR/HOMECOMPONENTS/AboutCCSU";
import Gallery from "./NAVBAR/HOMECOMPONENTS/Gallery";
import { ColorContext } from "./ColorContext";
import PrincipalsMessage from "./AboutUs/PrincipalsMessage";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import getUser from "../auth/userGetApi";
import LogoCollage from "../pages/LogoCollage.jpeg"
const Home = () => {
  const { bgColor } = useContext(ColorContext);
  const { isLoggedIn, userData, loginModale } = useSelector(
    (state) => state.auth,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Helper function to check if admission is from current year
  const isCurrentYearAdmission = (admission) => {
    if (!admission) return false;
    const admissionYear = new Date(admission.created_at).getFullYear();
    const currentYear = new Date().getFullYear();
    return admissionYear === currentYear;
  };

  const getIdCard = () => {
    if (isLoggedIn) {
      navigate(`/`, { replace: true });
    } else {
      dispatch({ type: "LOGINMODALE", payload: true });
    }
  };

  const getAdmissionForm = () => {
    if (isLoggedIn) {
      navigate(`/admission-form`, { replace: true });
    } else {
      dispatch({ type: "LOGINMODALE", payload: true });
    }
  };

  // Determine which admission button to show
  const getAdmissionButtonText = () => {
    if (!isLoggedIn || !userData) {
      return {
        showFirstYear: true,
        showSecondYear: true,
        firstYearText: "1st Year Admission-2026-27 Open Now 🎓",
        secondYearText: "2nd Year Admission-2026-27 Open Now 🎓",
      };
    }

    const admissions = userData?.admissions || [];
    const admissionLength = admissions.length;

    // Case 1: No admissions - Show 1st Year only
    if (admissionLength === 0) {
      return {
        showFirstYear: true,
        showSecondYear: false,
        firstYearText: "1st Year Admission-2026-27 Open Now 🎓📚",
        secondYearText: "",
      };
    }

    // Get the latest admission
    const latestAdmission = admissions[admissions.length - 1];
    const isCurrentYear = isCurrentYearAdmission(latestAdmission);

    // Case 2: Exactly 1 admission
    if (admissionLength === 1) {
      // If the admission is from current year, student has already filled form
      // Show nothing (or could show a message)
      if (isCurrentYear) {
        return {
          showFirstYear: false,
          showSecondYear: false,
          firstYearText: "",
          secondYearText: "",
          message: "You have already submitted your admission form for this year.",
        };
      } 
      // If admission is from previous year, show 2nd Year form
      else {
        return {
          showFirstYear: false,
          showSecondYear: true,
          firstYearText: "",
          secondYearText: "2nd Year Admission-2026-27 Open Now 🎓📚",
        };
      }
    }

    // Case 3: 2 or more admissions
    if (admissionLength >= 2) {
      // Check if the latest admission is from current year
      if (isCurrentYear) {
        // Already filled current year form
        return {
          showFirstYear: false,
          showSecondYear: false,
          firstYearText: "",
          secondYearText: "",
          message: "You have already submitted your admission form for this year.",
        };
      } else {
        // Show the appropriate year form
        // If they have 2 admissions, they need 3rd year form
        // If they have more, they've completed all years
        if (admissionLength === 2) {
          return {
            showFirstYear: false,
            showSecondYear: true,
            firstYearText: "",
            secondYearText: "3rd Year Admission-2026-27 Open Now 🎓📚",
          };
        } else {
          return {
            showFirstYear: false,
            showSecondYear: false,
            firstYearText: "",
            secondYearText: "",
            message: "You have completed all years of admission.",
          };
        }
      }
    }

    // Default fallback
    return {
      showFirstYear: true,
      showSecondYear: false,
      firstYearText: "1st Year Admission-2026-27 Open Now 🎓📚",
      secondYearText: "",
    };
  };

  const admissionButtonData = getAdmissionButtonText();

  return (
    <div>
      <div className="admission-portal-main-section">
        <div>
          <div>
            <h1 onClick={() => console.log(userData)}>Admission Portal</h1>
          </div>
          <div>
            <img
              src={
               LogoCollage
              }
            />
            <h1>Government Degree College Milak Rampur (U.P.)</h1>
            <p>ADMISSION-2026-27</p>
          </div>
          <div>
            <p>
              Government Degree College Milak Rampur (U.P.) में शैक्षणिक
              सत्र 2026-27 के लिए प्रवेश प्रक्रिया प्रारम्भ हो चुकी है।
              प्रथम वर्ष (1st Year) एवं द्वितीय वर्ष (2nd Year) के सभी
              छात्र-छात्राओं को सूचित किया जाता है कि वे समय रहते प्रवेश
              पोर्टल पर जाकर अपना प्रवेश फॉर्म भरें तथा आवश्यक दस्तावेजों के
              साथ प्रवेश प्रक्रिया पूर्ण करें। अंतिम तिथि का इंतजार न करें
              और अपना प्रवेश शीघ्र सुनिश्चित करें।
            </p>

            {isLoggedIn ? (
              <>
                {/* Case 1: Show 1st Year Admission */}
                {admissionButtonData.showFirstYear && (
                  <h1
                    onClick={() => getAdmissionForm()}
                    className="Admission-button"
                  >
                    {admissionButtonData.firstYearText}
                  </h1>
                )}

                {/* Case 2 & 3: Show 2nd/3rd Year Admission */}
                {admissionButtonData.showSecondYear && (
                  <h1
                    onClick={() => getAdmissionForm()}
                    className="Admission-button"
                  >
                    {admissionButtonData.secondYearText}
                  </h1>
                )}

                {/* Show message if form already submitted */}
                {admissionButtonData.message && (
                  <div className="admission-complete-message">
                    <p>{admissionButtonData.message}</p>
                    <button 
                      onClick={() => navigate('/admission-form')}
                      className="Admission-button"
                    >
                      View Your Admission Status
                    </button>
                  </div>
                )}
              </>
            ) : (
              <>
                <h1
                  onClick={() => getAdmissionForm()}
                  className="Admission-button"
                >
                  1st Year Admission-2026-27 Open Now 🎓
                </h1>
                <h1
                  onClick={() => getAdmissionForm()}
                  className="Admission-button"
                >
                  2nd Year Admission-2026-27 Open Now 🎓
                </h1>
              </>
            )}
          </div>
        </div>

        {isLoggedIn && userData?.admissions?.length > 0 ? (
          <div>
            <div>
              <h1>Get ID Card</h1>
            </div>
            <div>
              <p>
                Government Degree College Milak Rampur (U.P.) के
                छात्र-छात्राओं को सूचित किया जाता है कि अब वे प्रवेश
                पोर्टल के माध्यम से अपना College ID Card डाउनलोड कर सकते
                हैं। यह ID Card महाविद्यालय में पहचान पत्र के रूप में
                मान्य होगा तथा परीक्षाओं (Examinations) के दौरान भी
                आवश्यक दस्तावेज के रूप में उपयोग किया जाएगा। सभी
                छात्र-छात्राएं अपना ID Card डाउनलोड कर सुरक्षित रखें एवं
                आवश्यकता अनुसार उसका प्रिंट प्राप्त कर लें।
              </p>
              <h1>Get ID Card</h1>
              <Link
                to={`/id-card/${userData?.name}`}
                onClick={getIdCard}
                className="Admission-button"
              >
                Download Your College Identity Card Online 🎓🪪
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <div>
              <h1>Get ID Card</h1>
            </div>
            <div>
              <p>
                Government Degree College Milak Rampur (U.P.) के
                छात्र-छात्राओं को सूचित किया जाता है कि अब वे प्रवेश पोर्टल
                के माध्यम से अपना College ID Card डाउनलोड कर सकते हैं। यह ID
                Card महाविद्यालय में पहचान पत्र के रूप में मान्य होगा तथा
                परीक्षाओं (Examinations) के दौरान भी आवश्यक दस्तावेज के रूप
                में उपयोग किया जाएगा। सभी छात्र-छात्राएं अपना ID Card
                डाउनलोड कर सुरक्षित रखें एवं आवश्यकता अनुसार उसका प्रिंट
                प्राप्त कर लें।
              </p>
              <h1>Get ID Card</h1>
              <Link
                to={`/id-card/${userData?.name}`}
                onClick={getIdCard}
                className="Admission-button"
              >
                Download Your College Identity Card Online 🎓🪪
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;